import React from "react";
import ModalHelpItem from "../../components/inspection-sheet/ModalHelpItem";
import { ModalHelp } from "../../components/modal";

const InspectionSheetModalHelp = ({
  openModal,
  setOpenModal,
  inspectionSymbol,
}) => {
  return (
    <ModalHelp openModal={openModal} setOpenModal={setOpenModal} size="xl">
      <div className="py-2 pl-7">
        <ModalHelpItem
          color={inspectionSymbol.passed.color}
          background={inspectionSymbol.passed.background}
          symbol={inspectionSymbol.passed.symbol}
          label="点検OK"
          firstItem
        />
        <ModalHelpItem
          color={inspectionSymbol.failed.color}
          background={inspectionSymbol.failed.background}
          symbol={inspectionSymbol.failed.symbol}
          label="点検結果NGあり"
        />
        <ModalHelpItem
          color={inspectionSymbol.treatment_completed.color}
          background={inspectionSymbol.treatment_completed.background}
          symbol={inspectionSymbol.treatment_completed.symbol}
          label="処置完了済"
        />
        <ModalHelpItem
          color={inspectionSymbol.not_inspected.color}
          background={inspectionSymbol.not_inspected.background}
          symbol={inspectionSymbol.not_inspected.symbol}
          label="未点検 / 未承認"
        />
        <ModalHelpItem
          color={inspectionSymbol.other_okng.color}
          background={inspectionSymbol.other_okng.background}
          symbol={inspectionSymbol.other_okng.symbol}
          label="OKNG対象外 / 設備が停止中のため点検しない"
        />
      </div>
    </ModalHelp>
  );
};

export default InspectionSheetModalHelp;
